import TemplateTask from "../../entities/templateTask";

/**
 * TemplateTask actions
 *
 * Call order:
 *
 * TEMPLATETASK_SAVE_QUEUE:	adds the item to the save queue
 * --> TEMPLATETASK_SAVE:	modifies the state
 * --> TEMPLATETASK_SAVE_SUCCESS: if all went well
 * --> TEMPLATETASK_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail TEMPLATETASK_SAVE_QUEUE is during the call to TEMPLATETASK_SAVE,
 * as adding an item to the queue should never fail.
 */

export const TEMPLATETASK_FETCH_ONE_QUEUE: any = 'TEMPLATETASK_FETCH_ONE_QUEUE';
export const TEMPLATETASK_FETCH_SUCCESS: any = 'TEMPLATETASK_FETCH_SUCCESS';
export const TEMPLATETASK_FETCH_FAILURE: any = 'TEMPLATETASK_FETCH_FAILURE';
export const TEMPLATETASK_FETCH_ONE_SUCCESS: any = 'TEMPLATETASK_FETCH_ONE_SUCCESS';
export const TEMPLATETASK_FETCH_ONE_FAILURE: any = 'TEMPLATETASK_FETCH_ONE_FAILURE';

export const TEMPLATETASK_SAVE: any = 'TEMPLATETASK_SAVE';
export const TEMPLATETASK_SAVE_QUEUE: any = 'TEMPLATETASK_SAVE_QUEUE';
export const TEMPLATETASK_SAVE_SUCCESS: any = 'TEMPLATETASK_SAVE_SUCCESS';
export const TEMPLATETASK_SAVE_FAILURE: any = 'TEMPLATETASK_SAVE_FAILURE';

export const TEMPLATETASK_SAVE_MANY: any = 'TEMPLATETASK_SAVE_MANY';
export const TEMPLATETASK_SAVE_MANY_QUEUE: any = 'TEMPLATETASK_SAVE_MANY_QUEUE';
export const TEMPLATETASK_SAVE_MANY_SUCCESS: any = 'TEMPLATETASK_SAVE_MANY_SUCCESS';
export const TEMPLATETASK_SAVE_MANY_FAILURE: any = 'TEMPLATETASK_SAVE_MANY_FAILURE';

export const TEMPLATETASK_REMOVE: any = 'TEMPLATETASK_REMOVE';
export const TEMPLATETASK_REMOVE_QUEUE: any = 'TEMPLATETASK_REMOVE_QUEUE';
export const TEMPLATETASK_REMOVE_SUCCESS: any = 'TEMPLATETASK_REMOVE_SUCCESS';
export const TEMPLATETASK_REMOVE_FAILURE: any = 'TEMPLATETASK_REMOVE_FAILURE';

export const TEMPLATETASK_RESTORE: any = 'TEMPLATETASK_RESTORE';
export const TEMPLATETASK_RESTORE_QUEUE: any = 'TEMPLATETASK_RESTORE_QUEUE';
export const TEMPLATETASK_RESTORE_SUCCESS: any = 'TEMPLATETASK_RESTORE_SUCCESS';
export const TEMPLATETASK_RESTORE_FAILURE: any = 'TEMPLATETASK_RESTORE_FAILURE';

export const TEMPLATETASK_RESTORE_MANY: any = 'TEMPLATETASK_RESTORE_MANY';
export const TEMPLATETASK_REMOVE_MANY: any = 'TEMPLATETASK_REMOVE_MANY';

/* Fetch actions */
export const fetchTemplateTaskSuccess = (templateTasks: TemplateTask[], partial: boolean, lastFetch: number) => ({type: TEMPLATETASK_FETCH_SUCCESS, templateTasks, partial, lastFetch});
export const fetchTemplateTaskFailure = (err: any) => {
		console.error('TemplateTaskAction: fetchTemplateTaskFailure', err);
		return {type: TEMPLATETASK_FETCH_FAILURE, err};
};
export const fetchOneTemplateTaskQueue = (templateTaskId: string) => ({type: TEMPLATETASK_FETCH_ONE_QUEUE, templateTaskId});
export const fetchOneTemplateTaskSuccess = (templateTask: TemplateTask) => ({type: TEMPLATETASK_FETCH_ONE_SUCCESS, templateTask});
export const fetchOneTemplateTaskFailure = (id: string, err: any) => {
		console.error('TemplateTaskAction: fetchOneTemplateTaskFailure', err);
		return {type: TEMPLATETASK_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveTemplateTask = (templateTask: TemplateTask) => {
    // console.debug('⮂ TEMPLATETASK_SAVE action', templateTask?.id);
    return {type: TEMPLATETASK_SAVE, templateTask};
}
export const saveTemplateTaskQueue = (templateTask: TemplateTask) => {
    // console.debug('⮂ TEMPLATETASK_SAVE_QUEUE action', templateTask?.id);
    return {type: TEMPLATETASK_SAVE_QUEUE, templateTask};
}
export const saveTemplateTaskSuccess = (templateTask: TemplateTask) => {
    // console.debug('⮂ TEMPLATETASK_SAVE_SUCCESS action', templateTask?.id);
    return {type: TEMPLATETASK_SAVE_SUCCESS, templateTask};
}
export const saveTemplateTaskFailure = (templateTask: TemplateTask, status: number, message: string) => {
    console.warn(`⮂ TEMPLATETASK_SAVE_FAILURE error saving templateTask: HTTP ${status}: ${message}`, templateTask?.id);
    return {type: TEMPLATETASK_SAVE_FAILURE, templateTask, status, message};
};

/* SaveMany actions */
export const saveManyTemplateTasks = (templateTasks: TemplateTask[]) => {
    // console.debug('⮂ TEMPLATETASK_SAVE_MANY action', templateTasks?.map(templateTask => templateTask?.id).join(','));
    return {type: TEMPLATETASK_SAVE_MANY, templateTasks};
}
export const saveManyTemplateTasksQueue = (templateTasks: TemplateTask[]) => {
    // console.debug('⮂ TEMPLATETASK_SAVE_MANY_QUEUE action', templateTasks?.map(templateTask => templateTask.id).join(','));
    return {type: TEMPLATETASK_SAVE_MANY_QUEUE, templateTasks};
}

export const saveManyTemplateTasksSuccess = (templateTasks: TemplateTask[]) => {
    // console.debug('⮂ TEMPLATETASK_SAVE_MANY_SUCCESS action', templateTasks?.map(templateTask => templateTask.id).join(','));
    return {type: TEMPLATETASK_SAVE_MANY_SUCCESS, templateTasks};
}
export const saveManyTemplateTasksFailure = (templateTasks: TemplateTask[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_TEMPLATETASKS_FAILURE Error saving templateTasks: HTTP ${status}: ${message}`, templateTasks?.map(templateTask => templateTask.id).join(','));
		return {type: TEMPLATETASK_SAVE_MANY_FAILURE, templateTasks, status, message};
};

/* Remove actions */
export const removeTemplateTask = (templateTask: TemplateTask) => ({ type: TEMPLATETASK_REMOVE, templateTask });
export const removeTemplateTaskQueue = (templateTask: TemplateTask) => ({ type: TEMPLATETASK_REMOVE_QUEUE, templateTask });
export const removeTemplateTaskSuccess = (templateTask: TemplateTask) => ({ type: TEMPLATETASK_REMOVE_SUCCESS, templateTask });
export const removeTemplateTaskFailure = (templateTask: TemplateTask, status: number, message: string) => {
	console.error(`Redux: removeTemplateTaskFailure Error removing templateTask: HTTP ${status}: ${message}`);
	return ({ type: TEMPLATETASK_REMOVE_FAILURE, templateTask, status, message });
};

/* Restore actions */
export const restoreTemplateTask = (templateTask: TemplateTask) => ({ type: TEMPLATETASK_RESTORE, templateTask });
export const restoreTemplateTaskQueue = (templateTask: TemplateTask) => ({ type: TEMPLATETASK_RESTORE_QUEUE, templateTask });
export const restoreTemplateTaskSuccess = (templateTask: TemplateTask) => ({ type: TEMPLATETASK_RESTORE_SUCCESS, templateTask });
export const restoreTemplateTaskFailure = (templateTask: TemplateTask, status: number, message: string) => {
	console.error(`Redux: restoreTemplateTaskFailure Error restoring templateTask: HTTP ${status}: ${message}`);
	return ({ type: TEMPLATETASK_RESTORE_FAILURE, templateTask, status, message });
};

/* RestoreMany actions */
export const restoreManyTemplateTasks = (templateTasks: TemplateTask[]) => ({ type: TEMPLATETASK_RESTORE_MANY, templateTasks });

/* RemoveMany actions */
export const removeManyTemplateTasks = (templateTasks: TemplateTask[]) => ({ type: TEMPLATETASK_REMOVE_MANY, templateTasks });